import component from './RecentSearchAndPopulars';

export default component;
